import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PosSettingsPageRoutingModule } from './pos-settings-routing.module';

import { PosSettingsPage } from './pos-settings.page';

import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    PosSettingsPageRoutingModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule
  ],
  declarations: [PosSettingsPage]
})
export class PosSettingsPageModule {}
